import { type FC } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";

import { GenomeViewTile } from "../../core/tiles/index.js";
import { type Organism } from "@/graphql.ts";
import { TRACK_TYPE, UNKNOWN_GENOME_NAME } from "@/settings/settings.ts";

interface ResequencingDetailsCardProps extends GridCard {
  genome: Organism;
}

const ResequencingDetailsCard: FC<ResequencingDetailsCardProps> = (props) => {
  if (!props.genome || props.genome.name === UNKNOWN_GENOME_NAME) {
    return null;
  }

  return (
    <Card key="genome-info-card" title={"Resequencing Details"}>
      {props.genome.variantAnalysisGroups.map((analysisGroup, i) => {
        const refGenomes = analysisGroup?.refGenomes;
        if (refGenomes.length) {
          return (
            <CardRowSimple key={analysisGroup.name} label={analysisGroup.name}>
              {refGenomes.map((refGenome) => {
                return (
                  <GenomeViewTile
                    title={refGenome.name}
                    to={`/organism/${refGenome.id}/genome?add_tracks=${TRACK_TYPE.VCF_VARIANT}&preselected_mutants=${props.genome.id}`}
                    footNote={props.genome.origins[i] && `Origin: ${props.genome.origins[i]}`}
                  />
                );
              })}
            </CardRowSimple>
          );
        }
      })}
    </Card>
  );
};
export { ResequencingDetailsCard };
